import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Loading from '../Components/common/Loading';
import Sidebar from '../Components/Sidebar';
import NotificationContextProvider from '../contexts/NotificationContextProvider';
import {
    commonSelector,
    fetchAvailableServices,
    fetchUserProfile,
} from '../store/slices/common/commonSlice';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../helper/_cookieHelper';
import { getSubscriptionAlert } from '../services/apiService';
import Alert from '../Components/Alert/alert';

const Layout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const dispatch = useDispatch();
    const { loading, error, hotelDetails } = useSelector(commonSelector);
    const navigate = useNavigate();
    const [alertData, setAlertData] = useState(null);

    useEffect(() => {
        const token = getCookie('token');
        if (!token) {
            navigate('/login', { replace: true });
        }
    }, []);

    useEffect(() => {
        dispatch(fetchUserProfile());
        dispatch(fetchAvailableServices());
    }, []);

    useEffect(() => {
        const fetchAlertData = async () => {
            try {
                const response = await getSubscriptionAlert(
                    hotelDetails?.hotel_id
                );
                console.log(response.data.data);
                if (response.status === 200 && response?.data?.data) {
                    setAlertData(response.data.data);
                } else {
                    setAlertData(null);
                }
            } catch (error) {
                console.error('Error fetching alert data:', error);
                setAlertData(null);
            }
        };

        if (hotelDetails?.hotel_id) {
            fetchAlertData();
        }
    }, [hotelDetails?.hotel_id]);

    const collapsedClickHandler = () => {
        setCollapsed((prevstate) => !prevstate);
    };
    if (loading) return <Loading />;
    if (error) return <p>Something went wrong! Please talk to admin.</p>;

    const shouldShowAlert =
        alertData?.subscription_status &&
        alertData.subscription_status !== 'no_subscription' &&
        alertData.subscriptionStatus !== 'active';

    return (
        <NotificationContextProvider>
            <div className='app-wrapper'>
                <Sidebar
                    collapsed={collapsed}
                    collapsedClickHandler={collapsedClickHandler}
                />
                <div
                    className={
                        'main-layout ' + (collapsed ? 'collapsed-layout' : '')
                    }
                >
                    <Outlet />
                    {shouldShowAlert && (
                        <Alert
                            subscriptionStatus={alertData?.subscription_status}
                            message={alertData?.message}
                            formattedMessage={alertData?.formatted_message}
                            daysRemaining={alertData?.days_remaining}
                            endDate={alertData?.end_date}
                        />
                    )}
                </div>
            </div>
        </NotificationContextProvider>
    );
};

export default Layout;
